module.exports = __webpack_public_path__ + "img/epr_small.e8abb839.webp";